<template>
  <div class="create_wrapper">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->

    <div class="custom_card">
      <div class="card-header">
        <h4 class="card-title">{{ $t("edit") }}</h4>
      </div>

      <!-- ==== Start Form ==== -->
      <form @submit.prevent="validateCreateForm">
        <div class="container">
          <div class="row justify-content-between">
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  v-model="data.orders_count"
                />
                <label for="name_input" class="form-label"> عدد الطلبات </label>
              </div>
            </div>

            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  v-model="data.amount"
                />

                <label for="name_input" class="form-label"> الكمية </label>
              </div>
            </div>

            <!-- <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  v-model="data.max_discount"
                />
                <label for="name_input" class="form-label">
                  {{ $t('forms.labels.max_discount') }}
                </label>
              </div>
            </div> -->

            <!-- START:: DATE PICKER INPUT -->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label date_input">
                <label class="form-label">
                  {{ $t("forms.labels.start_date") }}
                </label>
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="data.start_date"
                      label="Picker without buttons"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="data.start_date"
                    @input="dateMenu = false"
                    :allowed-dates="disablePastDates"
                    no-title
                  ></v-date-picker>
                </v-menu>
              </div>
            </div>

            <!-- START:: DATE PICKER INPUT -->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label date_input">
                <label class="form-label">
                  {{ $t("forms.labels.end_date") }}
                </label>
                <v-menu
                  v-model="dateMenu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="data.end_date"
                      label="Picker without buttons"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="data.end_date"
                    @input="dateMenu2 = false"
                    :allowed-dates="disablePastDates2"
                    no-title
                  ></v-date-picker>
                </v-menu>
              </div>
            </div>

            <!-- Start:: Is Active -->
            <div class="col-lg-6 py-0">
              <v-checkbox
                :label="$t('forms.labels.is_active')"
                v-model="data.is_active"
                color="success"
              ></v-checkbox>
            </div>
            <!-- End:: Is Active -->
          </div>
        </div>

        <div class="buttons_wrapper">
          <button
            class="button_style_1"
            :class="btnIsLoading ? 'disabled' : ''"
          >
            {{ $t("forms.submit") }}
            <span class="btn_loader" v-if="btnIsLoading"></span>
          </button>
        </div>
      </form>
      <!-- ==== End Form ==== -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Create",
  props: ["id"],
  data() {
    return {
      dateMenu: false,
      dateMenu2: false,
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.bonus.title"),
          disabled: false,
          href: "/bonus/show-all",
        },
        {
          text: this.$t("breadcrumb.bonus.edit"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Loading
      btnIsLoading: false,

      // ========== create_data
      data: {
        // image: null,
        amount: null,
        orders_count: null,
        end_date: null,
        start_date: null,
        is_active: false,
      },
      start_time_modal: false,
      end_time_modal: false,
    };
  },

  computed: {},

  methods: {
    uplodeImg_1(obj) {
      this.data.image = obj;
    },
    all_apply_ids(ids, index) {
      if (this.data.applay_on.id != "all") {
        this.data.apply_ids[index] = ids;
      }
    },

    //Products
    appendProductRow() {
      this.data.products_rows.push({
        product: null,
        product_details_show: [],
        product_details_ids: [],
      });
    },
    deleteProductRow(index) {
      this.data.products_rows.splice(index, 1);
    },
    nameWithCode({ name, code }) {
      return `${name} — كود ${code}`;
    },
    subCatWithParent({ name, parent }) {
      return `${name} —  (${parent})`;
    },

    // getProductDetails(index, id) {
    //   this.$axios({
    //     method: "GET",
    //     url: `products/${id}`,
    //   }).then((res) => {
    //     this.data.products_rows[index].product_details_ids = [];
    //     this.data.products_rows[index].product_details_show =
    //       res.data.data.product_details;
    //   });
    // },

    // appendCategoryRow() {
    //   this.data.categories_rows.push({
    //     category: null,
    //     selected_categories: [],
    //   });
    // },
    // deleteCategoryRow(index) {
    //   this.data.categories_rows.splice(index, 1);
    // },

    disablePastDates(val) {
      return val >= new Date().toISOString().substr(0, 10);
    },
    disablePastDates2(val) {
      return val >= new Date(this.data.start_date).toISOString().substr(0, 10);
    },

    // Validate Data
    validateCreateForm() {
      this.btnIsLoading = true;

      if (!this.data.orders_count) {
        this.$iziToast.error({
          timeout: 2000,
          message: "يرجي إضافة عدد الطلبات",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.amount) {
        this.$iziToast.error({
          timeout: 2000,
          message: "يرجي إضافة الكمية",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.start_date) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.start_date"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.end_date) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.end_date"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else {
        this.submitData();
        return;
      }
    },

    // Submit Data
    submitData() {
      const submit_data = new FormData();
      submit_data.append("orders_count", this.data.orders_count);
      submit_data.append("amount", this.data.amount);
      submit_data.append("from", this.data.start_date);
      submit_data.append("to", this.data.end_date);
      submit_data.append("is_active", this.data.is_active ? 1 : 0);
      submit_data.append("_method", "PUT");
      this.$axios({
        method: "POST",
        url: `bonus/${this.id}`,
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("editSuccess"),
            position: "bottomRight",
          });
          this.$router.push({ path: "/bonus/show-all" });
          this.btnIsLoading = false;
        })
        .catch((err) => {
          let message = err.response.data.message ?? err.response.data.messages;
          this.$iziToast.error({
            timeout: 2000,
            message: message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },
    getData() {
      this.$axios.get(`bonus/${this.id}`).then((res) => {
        this.data.orders_count = res.data.data.orders_count;
        this.data.amount = res.data.data.amount;
        this.data.start_date = res.data.data.from;
        this.data.end_date = res.data.data.to;
        this.data.is_active = res.data.data.is_active;
      });
    },
  },

  created() {
    // this.getProducts();
    // this.getCategories();
    this.getData();
  },
};
</script>

<style lang="scss">
.productRow {
  border: 1px solid #339989;
  border-radius: 15px;
  padding: 10px 10px 20px 10px;
  margin-bottom: 20px;

  .detail {
    display: flex;
    align-items: center;

    &:not(:last-child) {
      margin-bottom: 10px;
    }
    .detail_show {
      border: 1px solid #339989;
      padding: 10px;
      flex-grow: 1;
      border-radius: 15px;
      position: relative;
      min-height: 100px;
      display: flex;
      align-items: center;
      justify-content: space-around;

      .rate {
        color: gray;
        position: absolute;
        top: 5px;
        left: 5px;
        font-size: 13px;

        span {
          color: yellow;
        }
      }

      .image {
        img {
          max-height: 50px;
        }
      }

      .color,
      .size {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
      }

      .image {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
      }

      .key {
        margin-bottom: 5px;
      }
    }
  }
}
</style>
